import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import FrequencyCapFields from '../../../formFields/FrequencyCapFields'

import { DISPLAY_DEFAULT, LINE_ITEM_TYPE, VIDEO_DEFAULT } from '../../fields'
import { FREQUENCY_IMPRESSIONS } from '../../../../../fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const stepFields = [FREQUENCY_IMPRESSIONS]

const LineItemTypeStep = ({ formik, handleStepChange }) => {
  const { t } = useTranslation()

  const drawerFormClasses = useDrawerFormStyles()

  const { values, setFieldValue } = formik

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle="Please select a line item type" handleContinue={handleContinue}>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={LINE_ITEM_TYPE + DISPLAY_DEFAULT}
        name={LINE_ITEM_TYPE}
        label={t('Display')}
        value={DISPLAY_DEFAULT}
        selectedValue={values[LINE_ITEM_TYPE]}
      >
        <div className={drawerFormClasses.subSection}>
          <FrequencyCapFields formik={formik} />
        </div>
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={LINE_ITEM_TYPE + VIDEO_DEFAULT}
        name={LINE_ITEM_TYPE}
        label={t('Video')}
        value={VIDEO_DEFAULT}
        selectedValue={values[LINE_ITEM_TYPE]}
      >
        <div className={drawerFormClasses.subSection}>
          <FrequencyCapFields formik={formik} />
        </div>
      </RadioBlock>
    </Step>
  )
}

export default LineItemTypeStep
